import instance from "../axios";
import React, { useEffect, useState } from "react";
import { requests } from "../requests";
import "../css/banner.css";

const Banner = () => {
  const [movie, setMovie] = useState([]);

  useEffect(() => {
    async function fetchData() {
      const request = await instance.get(requests.fetchNetflixOriginals);
      setMovie(
        request.data.results[
          Math.floor(Math.random() * request.data.results.length - 1)
        ]
      );
      return request;
    }

    fetchData();
  }, []);

  const truncate = (str, charNum) => str?.length > charNum ? str.substr(0, charNum -1) + "..."
: str;
  return (
    <header
      className="banner"
      style={{
        backgroundSize: "cover",
        backgroundImage: `URL("https://image.tmdb.org/t/p/original/${movie.backdrop_path}")`,
        backgroundPosition: "center center",
      }}
    >
      <div className="banner_content">
        <h1 className="banner_title">{movie?.title || movie?.name || movie?.original_name}</h1>

        <div className="banner_buttons">
          <button className="banner_button">Play</button>
          <button className="banner_button">List</button>
        </div>

        <h1 className="banner_description">
          {truncate(movie?.overview, 150)}
          {/* {movie?.overview} */}
        </h1>
      </div>
      <div className="banner_fadeBottom"/>
    </header>
  );
  //movie?.title :- movie === true ? movie.title : undefined;
};

export default Banner;
